// @flow
import React from 'react';
import { NumberUtil } from 'utils/NumberUtil';
import DotSeparator from 'components/atoms/dotSeparator';
import { EventTicketUserForm } from 'components/organisms/eventTicketUserForm';
import { useViewport } from 'components/templates/viewportProvider';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  onEditClick: () => void,
  data: Array<ticketDetails>,
};

type ticketDetails = {
  ticket_type: string,
  ticket_type_id: string,
  available_tickets?: number,
  price: number,
  selected: Array,
  total_cost: number,
};

const EventTicketCart = (props: Props) => {
  const { onEditClick, data, eventTimeID, onClosePress, eventTitle, eventDate } = props;
  const { isMobile } = useViewport();
  const getAmount = (amount) => {
    const total_amount = amount.toFixed(2);
    return NumberUtil.formatNumber(total_amount);
  }
  let cart_value =
     data.standing_tickets_data.total_cost +
     data.seating_tickets_data.total_cost;
    
  return (
    <div className={'ticket-cart-container'}>
      <div className={'heading'}>
        {isMobile ? (
          <h3 className={'heading-text'}>Your Booking Summary</h3>
        ) : (
          <h2 className={'heading-text'}>Your Booking Summary</h2>
        )}
        <h4 className={'edit-text'} onClick={onEditClick}>
          EDIT ORDER
        </h4>
      </div>
      {Object.values(data).map(ticketData => (
        <div className={'ticket-info-container'}>
          <h3 className={'ticket-type-name'}>
            {ticketData.ticket_type} Tickets
          </h3>
          <DotSeparator />
          <h3 className={'count'}>{ticketData.selected}</h3>
          <DotSeparator />
          <h3 className={'price-value'}>
            INR {getAmount(ticketData.total_cost)}
          </h3>
        </div>
      ))}
      <h4 className={'form-heading'}>
        Enter your details below to complete your booking
      </h4>
      <EventTicketUserForm
        className={'event-user-form'}
        cartValue={cart_value}
        tickets={{ ticketData: data, eventTimeID: eventTimeID }}
        onError={onClosePress}
        eventTitle={eventTitle}
        eventDate={eventDate}
      />
    </div>
  );
};
export default EventTicketCart;
